<template>
  <div ref="buttonContainer" class="qz-button" :class="classObject" :style="pStyleObject" @click.stop="handleClick">
    <div class="default-button" :class="btnClassObject" :style="styleObject">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QzButton',
  props: {
    type: { // 按钮类型，'warning'为红色按钮
      type: String,
      default: 'normal'
    },
    width: { // 按钮宽度
      type: Number,
      default: 0
    },
    minWidth: { // 按钮最小宽度
      type: Number,
      default: 0
    },
    height: { // 按钮高度
      type: Number,
      default: 0
    },
    size: { // 按钮的字体大小，取值为'normal', 'big', 'medium'
      type: String,
      default: 'normal'
    },
    fontSize: { // 按钮的字体大小
      type: Number,
      default: 12
    },
    right: { // 右边距
      type: Number,
      default: 0
    },
    left: { // 左边距
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    padding: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    classObject() {
      const btnBgColorEnum = {
        'warning': 'btn-delete',
        'normal': 'btn-normal',
        'warning-reverse': 'btn-delete-reverse',
        'normal-reverse': 'btn-normal-reverse'
      }
      const className = btnBgColorEnum[this.type]
      return {
        'disabled': this.btnDisabled,
        [className]: !!className,
        'no-enable': this.loading
      }
    },
    pStyleObject() {
      const baseStyle = {}
      const styleArray = ['left', 'right', 'backgroundColor']
      styleArray.map(attrName => {
        if (this[attrName]) {
          if (attrName === 'backgroundColor') {
            Object.assign(baseStyle, {
              'background-color': `${this[attrName]}`
            })
          } else {
            Object.assign(baseStyle, {
              [`margin-${attrName}`]: `${this[attrName]}px`
            })
          }
        }
      })
      return baseStyle
    },
    btnClassObject() {
      return {
        [this.size]: !!this.size
      }
    },
    btnDisabled() {
      const disabled = this.$attrs.disabled
      return disabled || disabled === ''
    },
    styleObject() {
      const baseStyle = {}
      const styleArray = ['width', 'height', 'minWidth', 'fontSize', 'color', 'padding']
      styleArray.map(attrName => {
        if (this[attrName]) {
          if (attrName === 'height') {
            Object.assign(baseStyle, {
              'lineHeight': `${this[attrName]}px`,
              'height': `${this[attrName]}px`
            })
          } else if (attrName === 'color') {
            Object.assign(baseStyle, {
              'color': `${this[attrName]}`
            })
          } else if (attrName === 'padding') {
            Object.assign(baseStyle, {
              'padding': `0 ${this[attrName]}px`
            })
          } else {
            Object.assign(baseStyle, {
              [this.splitCamelStr(attrName)]: `${this[attrName]}px`
            })
          }
        }
      })
      return baseStyle
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
    // 分割驼峰字符串
    splitCamelStr(str) {
      return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .qz-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    cursor: pointer;
    border-radius: 4px;
    &.disabled{
      pointer-events: none;
      background-color: #DCDCDF!important;
      .default-button{
         color: #1f6aff!important;
       }
    }
    &.no-enable {
      pointer-events: none;
    }
    &.btn-normal {
      background-color: $color-blue;
    }
    &.btn-normal-reverse {
      background-color: #fff;
      .default-button {
        color: $color-blue;
        border: 1px solid $color-blue;
        &:hover{
          opacity: 0.7;
        }
      }
    }
    &.btn-delete{
      background-color: #E75235;
    }
    &.btn-delete-reverse{
      background: #fff;
      .default-button {
        color: #E75235;
        border: 1px solid #E75235;
        &:hover{
          opacity: 0.7;
          /*background-color: #E75235;*/
          /*color: #fff;*/
        }
      }
    }
    // 定义按钮hover颜色
    &:not(.btn-normal-reverse):not(.btn-delete-reverse) {
      .default-button:hover {
        background-color: rgba(0, 0, 0, .2);
      }
    }
    .default-button {
      display: inline-block;
      padding: 0 12px;
      -moz-user-select: none;
      -khtml-user-select: none;
      user-select: none;
      text-align: center;
      color: #fff;
      border-radius: 4px;
      // box-shadow:0px 12px 16px 0px rgba(40,54,65,0.06);
      &.normal{
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
      }
      // 一般为页面上的功能处理按钮
      &.medium {
        height: 28px;
        line-height: 28px;
        padding: 0 16px;
      }
      // 一般为页面底部操作栏上的按钮
      &.big {
        height: 46px;
        line-height: 46px;
        padding: 0 16px;
      }
    }
  }
</style>
